import React, { useState } from "react";
import ParentCertBuilderRequests from "./ParentCertBuilderRequests";

const SwitchParentForm = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return <ParentCertBuilderRequests />;
      default:
        return <ParentCertBuilderRequests />;
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${step === 1 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Certificate Request</div>
          </div>
        </div>
        <div>{switchTab()}</div>
      </div>
    </>
  );
};

export default SwitchParentForm;
